import React from "react";
import {
  checkIsArrayEmpty,
  useIsDesktop,
} from "@my-scoot/exly-react-component-lib";
import { Header } from "common/Components/Header";
import { QuestionsActionField } from "features/Account/modules/Communications/modules/ContactForm/modules/ContactFormQuestionsList/modules/QuestionsActionField/QuestionsActionField";
import { EditQuestionForm } from "features/Account/modules/Communications/modules/ContactForm/modules/QuestionForm/modules/EditQuestionForm/EditQuestionForm";
import { SaveQuestionChangesModal } from "features/Account/modules/Communications/modules/ContactForm/modules/QuestionForm/modules/SaveQuestionChanges/modules/SaveQuestionChangesModal/SaveQuestionChangesModal";
import { DraggableTableWrapper } from "features/AdminPanel/modules/DraggableTableWrapper/DraggableTableWrapper";
import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";
import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import { SavingStatus } from "features/ManageOfferings/modules/SavingStatus/SavingStatus";
import arrayMutators from "final-form-arrays";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { Form } from "react-final-form";
import ExlyLoader from "ui/modules/ExlyLoader";
import useStyles from "./BookedSession.styles";
import AddQuestionsSuccess from "./components/AddQuestionsSuccess";
import { TableHeader } from "./components/TableHeader";
import QuestionsFormModal from "./QuestionsFormModal";
import { useBookedQuestions } from "./utils/useBookedQuestions";
import LearnMoreCta from "features/Common/modules/LearnMore/modules/LearnMoreCta/LearnMoreCta";
import { BOOKING_QUESTIONS_LEARN_MORE_HREFS } from "./constants";
import { Button } from "@my-scoot/component-library-legacy";
import { useStickyHeader } from "features/AdminPanel/modules/utils/useStickyHeader";

const initial_state = {
  questionObj: {},
};

export const BookedQuestions = withComponentLibraryTheme(() => {
  const classes = useStyles();
  const isDesktop = useIsDesktop();

  const { headerRef, sentinelRef } = useStickyHeader();

  const {
    closeModal,
    columnsConfig,
    handleAddBookingQuestion,
    handleDeleteBookingQuestion,
    handleEditBookingQuestion,
    handleMarkMandatoryBookingQuestion,
    handleTableReordering,
    isActionFieldsModalOpen,
    isFetching,
    onModalClose,
    openModal,
    openQuestionsModal,
    selectedRecord,
    isModalActive,
    questionsModal,
    afterBookingQuestions,
    beforeBookingQuestions,
    isEditQuestionModalOpen,
    setQuestionsModal,
    openEditQuestionmodal,
    handleToggleQuestionMandatory,
  } = useBookedQuestions();

  const secondaryComponent = (
    <div className="tw-flex tw-items-center tw-gap-3">
      <SavingStatus className="tw-mr-3" />
      <LearnMoreCta
        href={BOOKING_QUESTIONS_LEARN_MORE_HREFS.BOOKING_QUESTIONS}
      />
      <Button
        color="primary"
        size="medium"
        onClick={() => setQuestionsModal(true)}
        className=""
      >
        Add Question
      </Button>
    </div>
  );

  return (
    <div>
      {isDesktop && <div className="tw-mt-4" ref={sentinelRef} />}

      {isDesktop && (
        <Header
          rootRef={headerRef}
          hideBackButton
          title="Booking Questions"
          right={secondaryComponent}
          classNames={{
            container:
              "tw-sticky tw-top-0 tw-py-6 tw-mx-12 tw-z-10 max-md:tw-static tw-transition-all tw-duration-300 tw-bg-white",
            title: "!tw-text-[24px] !tw-font-bold",
          }}
        />
      )}

      {!isDesktop && <SavingStatus />}

      {!isDesktop && isActionFieldsModalOpen && (
        <QuestionsActionField
          handleDeleteQuestion={handleDeleteBookingQuestion}
          openEditQuestionmodal={openEditQuestionmodal}
          record={selectedRecord}
        />
      )}

      {isFetching ? (
        <ExlyLoader showText={false} />
      ) : (
        <div className="md:tw-px-0 tw-px-3">
          {/* PRE BOOKING QUESTIONS TABLE */}
          {!checkIsArrayEmpty(beforeBookingQuestions) && (
            <div className="md:tw-py-6 md:tw-pb-3 md:tw-mx-12">
              <TableHeader
                title="Pre-Booking Form"
                imgSrc={getS3AssetCDNUrl(
                  "assets/vectors/dashboard/booking_checkbook.png"
                )}
              />
              <DraggableTableWrapper
                initialData={beforeBookingQuestions}
                columnConfig={columnsConfig}
                onReOrder={handleTableReordering}
                handleToggleQuestionMandatory={
                  handleMarkMandatoryBookingQuestion
                }
              />
            </div>
          )}

          {/* POST BOOKING QUESTIONS TABLE */}
          {!checkIsArrayEmpty(afterBookingQuestions) && (
            <div className="md:tw-py-6  md:tw-mx-12">
              <TableHeader
                title="Post-Booking Form"
                imgSrc={getS3AssetCDNUrl(
                  "assets/vectors/dashboard/post_booking_checkbook.png"
                )}
              />

              <DraggableTableWrapper
                initialData={afterBookingQuestions}
                columnConfig={columnsConfig}
                onReOrder={handleTableReordering}
                handleToggleQuestionMandatory={handleToggleQuestionMandatory}
              />
            </div>
          )}

          <LazyLoadWrapper loadingCondition={questionsModal}>
            <Form
              initialValues={initial_state}
              onSubmit={handleAddBookingQuestion}
              mutators={{
                ...arrayMutators,
              }}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  {questionsModal && (
                    <QuestionsFormModal
                      title={"Add Booking Question"}
                      openModal={openModal}
                      isOpen={questionsModal}
                      closeModal={closeModal}
                      addNewQuestion={handleAddBookingQuestion}
                      initial_state={initial_state}
                      handleSubmit={handleSubmit}
                      ctaText={"Add Question"}
                    />
                  )}
                  {isModalActive && (
                    <AddQuestionsSuccess
                      open={isModalActive}
                      onClose={onModalClose}
                      classes={classes}
                      openQuestionsModal={openQuestionsModal}
                    />
                  )}
                </form>
              )}
            </Form>
          </LazyLoadWrapper>

          <LazyLoadWrapper loadingCondition={isEditQuestionModalOpen}>
            <EditQuestionForm handleEditQuestion={handleEditBookingQuestion} />
          </LazyLoadWrapper>

          <SaveQuestionChangesModal />
        </div>
      )}
    </div>
  );
});
